export const NOTABLE_CLIENTS_ORIGIN = 'gig_page';
